import React from 'react';

import { ExtendedReportTemplateList } from '@futrli/views/processors/reports/reportTemplatesList';
import { ListingPageRowActions } from '@futrli/ui-components/components/listing-page/listing-page-row/listing-page-row-actions/listing-page-row-actions';

import { useReportTemplateActionItems } from './hooks/use-report-template-action-items';

interface ReportTemplateActionsPopoverProps {
  template: ExtendedReportTemplateList;
  onDelete?: () => void;
  onPublish?: () => void;
}

export const ReportTemplateActionsPopover = ({ template, onDelete, onPublish }: ReportTemplateActionsPopoverProps) => {
  const items = useReportTemplateActionItems({ template, onDelete, onPublish });

  return <ListingPageRowActions items={items} />;
};
